/**
 * Which insight rows a selected branch covers.
 *
 * Its own module, with no imports: EnSightTab pulls in axios, which this repo's
 * jest config does not transform, so a rule tested through the component cannot be
 * tested at all.
 */

/**
 * Does this insight row belong to the selected branch?
 *
 * `branchMachineNames` is null when no branch is selected, AND when BranchContext
 * has not yet resolved which machine sits under which branch. Both mean "hide
 * nothing": filtering against an unresolved map would empty the table rather than
 * narrow it, which reads as broken insights rather than as a filter.
 *
 * The branch node's own name passes too. BranchContext skips is_branch nodes while
 * building its maps, so a row reported against the branch itself would otherwise be
 * excluded from the branch it names.
 */
export function rowInBranch(row, branchMachineNames, selectedBranch) {
  if (!branchMachineNames) return true;
  if (!row || !row.machine) return false;
  if (row.machine === selectedBranch) return true;
  return branchMachineNames.has(row.machine);
}
